import { useState } from "react";
import { useNavigate } from "react-router-dom";

const slides = [
  {
    id: 0,
    title: "Buy Crypto with Naira",
    subtitle: "Instantly exchange your Nigerian Naira for Bitcoin, Ethereum, USDT and more. Powered Dealdrive Technology — fast, secure & reliable.",
    image: "https://readdy.ai/api/search-image?query=clean%20minimal%20cryptocurrency%20bitcoin%20gold%20coins%20floating%20on%20soft%20white%20background%20with%20light%20green%20accents%20geometric%20shapes%20representing%20modern%20fintech%20wealth%20growth%20premium%20design&width=400&height=400&seq=ob1light&orientation=squarish",
    accent: "#059669",
  },
  {
    id: 1,
    title: "Deposit & Sell Anytime",
    subtitle: "Send crypto from any external wallet. When confirmed, sell for Naira instantly at live market rates — no delays, no hassle.",
    image: "https://readdy.ai/api/search-image?query=clean%20minimal%20digital%20wallet%20with%20flowing%20naira%20currency%20notes%20transforming%20into%20cryptocurrency%20tokens%20on%20soft%20white%20background%20with%20emerald%20green%20accents%20premium%20fintech%20illustration&width=400&height=400&seq=ob2light&orientation=squarish",
    accent: "#059669",
  },
  {
    id: 2,
    title: "Withdraw to Your Bank",
    subtitle: "Get your Naira straight to your GTBank, Access, Zenith or any Nigerian bank. Crypto withdrawals to any wallet — worldwide.",
    image: "https://readdy.ai/api/search-image?query=clean%20minimal%20Nigerian%20bank%20card%20and%20smartphone%20with%20digital%20transfer%20arrows%20on%20soft%20white%20background%20with%20light%20green%20accents%20representing%20seamless%20money%20withdrawal%20premium%20fintech%20design&width=400&height=400&seq=ob3light&orientation=squarish",
    accent: "#059669",
  },
];

export default function Onboarding() {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  const slide = slides[current];

  const vibrate = (ms = 20) => {
    if (navigator.vibrate) navigator.vibrate(ms);
  };

  const handleNext = () => {
    vibrate();
    if (current < slides.length - 1) {
      setCurrent(current + 1);
    } else {
      localStorage.setItem('hasSeenOnboarding', 'true');
      navigate('/auth');
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-between px-6 py-10 overflow-hidden">
      {/* Top bar */}
      <div className="w-full max-w-sm flex justify-between items-center">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-xl bg-emerald-600 flex items-center justify-center">
            <i className="ri-exchange-line text-white text-sm"></i>
          </div>
          <span className="text-slate-800 font-bold text-base" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Makkytrade</span>
        </div>
        <button onClick={() => navigate("/auth")} className="text-slate-400 text-sm hover:text-slate-600 transition-colors whitespace-nowrap cursor-pointer">Skip</button>
      </div>

      {/* Image */}
      <div className="w-72 h-72 md:w-80 md:h-80 rounded-3xl overflow-hidden border border-slate-100 bg-slate-50">
        <img src={slide.image} alt={slide.title} className="w-full h-full object-cover object-top" />
      </div>

      {/* Text */}
      <div className="w-full max-w-sm text-center">
        <h1 className="text-slate-800 text-3xl font-bold mb-3 leading-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          {slide.title}
        </h1>
        <p className="text-slate-500 text-sm leading-relaxed mb-8">{slide.subtitle}</p>

        {/* Dots */}
        <div className="flex justify-center gap-2 mb-8">
          {slides.map((_, i) => (
            <button key={i} onClick={() => setCurrent(i)} className="transition-all duration-300 rounded-full cursor-pointer"
              style={{ width: i === current ? "28px" : "8px", height: "8px", background: i === current ? "#059669" : "#E2E8F0" }} />
          ))}
        </div>

        <button onClick={handleNext}
          className="w-full py-4 rounded-2xl text-white font-semibold text-base whitespace-nowrap transition-all duration-200 active:scale-95 bg-emerald-600 hover:bg-emerald-700">
          {current === slides.length - 1 ? "Get Started" : "Continue"}
        </button>

        <p className="text-slate-400 text-sm mt-4">
          Already have an account?{" "}
          <button onClick={() => navigate("/auth")} className="text-emerald-600 font-semibold cursor-pointer">Sign In</button>
        </p>
      </div>
    </div>
  );
}
